const faqs = [
  {
    q: '91浏览器真的免费吗？',
    a: '是的，91浏览器完全免费，无任何隐藏费用。我们通过为企业客户提供定制化浏览器解决方案来维持运营，个人用户永久免费使用全部功能。',
  },
  {
    q: '91浏览器网页版和客户端有什么区别？',
    a: '网页版无需安装，打开网页即可使用核心功能，适合临时或轻量使用场景。客户端版功能更全面，支持离线浏览、本地文件管理、系统级通知等高级功能。建议日常使用客户端版以获得最佳体验。',
  },
  {
    q: '我的浏览数据会被收集吗？',
    a: '91浏览器坚持隐私优先原则，不收集用户的个人浏览数据。所有同步数据采用端到端加密，加密密钥仅存储在您的设备本地，我们的服务器无法解密。您可以随时在隐私面板查看详细的拦截报告。',
  },
  {
    q: '如何在多台设备间同步数据？',
    a: '只需在每台设备上登录同一个91账号，书签、密码、历史记录等数据会自动同步。同步过程采用增量传输和端到端加密，安全又高效。',
  },
  {
    q: '91浏览器支持哪些扩展插件？',
    a: '91浏览器兼容Chrome Web Store中的绝大多数扩展插件，您可以自由安装使用。此外，我们的插件商店还提供了许多专为中文用户优化的特色插件。',
  },
  {
    q: '如何反馈问题或提出建议？',
    a: '您可以通过浏览器内置的"帮助与反馈"功能提交问题，或发送邮件至 support@91browser.com。我们的技术支持团队通常会在24小时内回复。',
  },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.a,
    },
  })),
};

export default function FAQSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            关于<strong className="text-primary-500">91浏览器</strong>的常见疑问
          </h2>
          <p className="text-foreground-600 text-sm">
            这里汇总了用户最关心的问题，帮您快速找到答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="text-sm font-medium text-foreground-950 pr-8">{faq.q}</span>
                <span className="w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-secondary-600 text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}